require('./roundProgress.min.js');
module.exports = 'angular-svg-round-progressbar';